import { convertToIsoDateTime } from "@common/components/helpers/datetime";

const unresolvedDisputeCreatePayload = (data, siteGuid) => {
  const { customer, customerId } = data;
  return {
    id: data.id,
    rowVersion: data.rowVersion,
    incidentDate: convertToIsoDateTime(data.date, data.time),
    incidentStatus: {
      id: 2,
      name: "In Review",
    },
    incidentType: {
      id: 4,
      name: "Unresolved Gambling Dispute",
    },
    site: { guid: siteGuid },
    customerIncident: null,
    enforcementVisit: null,
    gamblingDispute: {
      ...data,
      capturedByCctv: data.cctvCatched,
      gamblingDisputeDetails: data.description,
      customerId: customerId ?? customer.id,
      customer: customerId || customer.id ? null : data.customer,
      gamblingDisputeType: {
        id: data.type,
        name: "",
      },
    },
    suspiciousActivity: null,
  };
};

export default unresolvedDisputeCreatePayload;
